import { render, staticRenderFns } from "./AcceleratorDocs.vue?vue&type=template&id=325b0058&scoped=true&"
import script from "./AcceleratorDocs.vue?vue&type=script&lang=js&"
export * from "./AcceleratorDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325b0058",
  null
  
)

export default component.exports